import { useCallback } from "react";
import { Observable } from "@legendapp/state";
import { use$ } from "@legendapp/state/react";
import { PrimeIcons } from "primereact/api";
import type { SidePanelState } from "../types/SidePanel.types";

const {
  ARROW_DOWN_LEFT_AND_ARROW_UP_RIGHT_TO_CENTER: shrinkIcon,
  ARROW_UP_RIGHT_AND_ARROW_DOWN_LEFT_FROM_CENTER: expandIcon,
} = PrimeIcons;

const useFullScreenToggle = (state$: Observable<SidePanelState>) => {
  const isFullScreen = use$(state$.isFullScreen);

  return useCallback(() => {
    const fullScreenState = !isFullScreen;

    state$.assign({
      icon: fullScreenState ? shrinkIcon : expandIcon,
      isFullScreen: fullScreenState,
    });
  }, [isFullScreen, state$]);
};

export default useFullScreenToggle;
